import { render, staticRenderFns } from "./newMysteryItems.vue?vue&type=template&id=df00f732"
import script from "./newMysteryItems.vue?vue&type=script&lang=js"
export * from "./newMysteryItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports